module.exports = __webpack_public_path__ + "assets/a6ec1f811d289c7648191d018cf59ee9.mp3";